var nanobus = require('nanobus');
var HideOnScreen = /** @class */ (function () {
    function HideOnScreen(element) {
        this.element = element;
        this.settings = [];
        this.init();
    }
    HideOnScreen.prototype.init = function () {
        var _this = this;
        if (document.querySelector('.ac-boxes.disabled')) {
            return;
        }
        this.element.querySelectorAll('[data-setting]').forEach(function (el) {
            var setting = new Setting(el);
            setting.events.on('change', function () {
                _this.checkDependent(setting);
            });
            _this.settings.push(setting);
        });
        this.settings.forEach(function (s) { return s.events.emit('change'); });
    };
    HideOnScreen.prototype.checkDependent = function (setting) {
        var checked = setting.isChecked();
        this.settings.forEach(function (rel_setting) {
            if (rel_setting.isDependentOn(setting.getName())) {
                checked
                    ? rel_setting.disable()
                    : rel_setting.enable();
            }
        });
    };
    return HideOnScreen;
}());
export default HideOnScreen;
var Setting = /** @class */ (function () {
    function Setting(element) {
        this.element = element;
        this.name = element.dataset.setting;
        this.checkbox = element.querySelector('input[type=checkbox]');
        this.dependentOn = element.dataset.dependent.split(',');
        this.events = nanobus();
        this.initEvents();
    }
    Setting.prototype.initEvents = function () {
        var _this = this;
        this.checkbox.addEventListener('change', function () {
            _this.events.emit('change');
        });
    };
    Setting.prototype.disable = function () {
        this.element.classList.add('-disabled');
        this.setChecked(true);
        this.checkbox.setAttribute('disabled', 'true');
        this.events.emit('change');
    };
    Setting.prototype.enable = function () {
        this.element.classList.remove('-disabled');
        this.checkbox.removeAttribute('disabled');
        this.events.emit('change');
    };
    Setting.prototype.setChecked = function (setChecked) {
        this.checkbox.checked = setChecked;
        this.events.emit('change');
    };
    Setting.prototype.getName = function () {
        return this.name;
    };
    Setting.prototype.isChecked = function () {
        return this.checkbox.checked;
    };
    Setting.prototype.isDependentOn = function (name) {
        return this.dependentOn.includes(name);
    };
    return Setting;
}());
